import { TabNotifiche } from "./tab-notifiche.model"

export class InsertNotificheIn {
    listIdUserA: number[]
    tabNotifiche: TabNotifiche

}
